export const Loader: React.FC<unknown> = () => {
    return (
        <div className="flex items-center justify-center space-x-2 animate-pulse m-2">
            <div className="w-3 h-3 bg-primary rounded-full"></div>
            <div className="w-3 h-3 bg-primary rounded-full"></div>
            <div className="w-3 h-3 bg-primary rounded-full"></div>
        </div>
    )
}
